module.exports = __webpack_public_path__ + "img/icon_flag_chn.05b63e9c.png";